import { ArnValidDataConfig, UrlUtil } from '@arianee/arn-types';
import { ArnDataConfig } from './ArnDataConfig';
import { DefaultArnDataService } from './DefaultArnDataService';
import { ArnHttpService } from '../http';
import { ArnAuthService } from '../auth';
import { ArnDataServiceFactory } from './ArnDataServiceFactory';
import { ArnDataService } from './ArnDataService';

export class DefaultArnDataServiceFactory implements ArnDataServiceFactory {
  createConfig(spec?: ArnDataConfig, serverUrl?: string): ArnValidDataConfig {
    return {
      url: UrlUtil.build(spec?.url, 'data', serverUrl),
    };
  }

  create(
    http: ArnHttpService,
    auth: ArnAuthService,
    spec?: ArnDataConfig,
    serverUrl?: string
  ): ArnDataService {
    const config = this.createConfig(spec, serverUrl);
    return new DefaultArnDataService(config, http, auth);
  }
}
